/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTE1IDE1SDFWNS43Mzk5OUg1LjZMNy42NyA3LjYxOTk5SDE1VjE1Wk0yIDE0SDE0VjguNjE5OTlINy4yOEw1LjIgNi43Mzk5OUgyVjE0WiIgZmlsbD0iaW5oZXJpdCIvPjxwYXRoIGQ9Ik0xMy45OSA3Ljg2SDEyLjk5VjJINFY1Ljk5SDNWMUgxMy45OVY3Ljg2WiIgZmlsbD0iaW5oZXJpdCIvPjxwYXRoIGQ9Ik0xMS4wMiAzLjU0OTk5SDUuOTg5OTlWNC41NDk5OUgxMS4wMlYzLjU0OTk5WiIgZmlsbD0iaW5oZXJpdCIvPg==";